// extracted by mini-css-extract-plugin
module.exports = {"plan":"src-components-Pricing-PricingPlanComponent-index-module__plan--xKZc9","planHighlighted":"src-components-Pricing-PricingPlanComponent-index-module__planHighlighted--jdvCz"};